import { CompassFilled, FieldTimeOutlined, FileTextOutlined, FormOutlined, ShopOutlined } from '@ant-design/icons'
import { SiteNotes } from '@components/Admin/Site/Grid/Detail/SiteNotes'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { useLocalStorage } from '@gravitate-js/the-armory'
import { Col, Menu, Row, Form, Select } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { GraviButton, Texto } from '@gravitate-js/excalibrr'

import { Info } from './Info'
import { LayoutPdf } from './LayoutPdf'
import { MapLocation } from './MapLocation'
import { TankMonitor } from './TankMonitor'
import { UnavailableHours } from './UnavailableHours'

// Mock data for freight regions - in real implementation this would come from props or API
const MOCK_FREIGHT_REGIONS = [
  { region_id: 1, name: 'Northeast' },
  { region_id: 2, name: 'Southeast' },
  { region_id: 3, name: 'Midwest' },
  { region_id: 4, name: 'West' },
]

export function RowExpanded({ data, storeMetadata }) {
  const { scopes } = useSecurityContext()
  const canEditStores = scopes.admin?.site_write
  // have to use local storage here because of how AG Grid will render the expand
  const { value: selectedRightMenuItem, setValue: setSelectedRightMenuItem } = useLocalStorage(
    'selected-site-management-menu',
    'map_location'
  )

  const { sectors, counterparties, monitoring_strategies: monitorStrategies } = storeMetadata

  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const menuItems = useMemo(() => {
    const items = [
      {
        label: (
          <>
            <CompassFilled className='pr-2' />
            Map Location
          </>
        ),
        key: 'map_location',
      },
      {
        label: (
          <>
            <ShopOutlined className='pr-2' />
            Site Layout PDF
          </>
        ),
        key: 'store_layout_pdf',
      },
      {
        label: (
          <>
            <FieldTimeOutlined className='pr-2' />
            Unavailable Hours
          </>
        ),
        key: 'Unavailable_hours',
      },
      {
        label: (
          <>
            <FileTextOutlined className='pr-2' />
            Site Notes
          </>
        ),
        key: 'Site_notes',
      },
    ]
    if (!['Unmonitored', 'Updated via Integration'].includes(data.monitoring_strategy)) {
      items.push({
        label: (
          <>
            <FormOutlined className='pr-2' />
            Tank Monitor Configuration
          </>
        ),
        key: 'tank_monitor',
      })
    }
    return items
  }, [data.monitoring_strategy])

  const handleValuesChange = (changedValues) => {
    // In real implementation, this would call the API to update the site
    console.log('Updated values:', changedValues)
  }

  return (
    <Row className='ml-2 bg-1 mb-5'>
      <Col span={11} className='p-2'>
        <Info
          store={data}
          sectors={sectors}
          loading={loading}
          setLoading={setLoading}
          monitorStrategies={monitorStrategies}
          counterparties={counterparties}
        />
      </Col>
      <Col span={3} className='p-2'>
        <Menu
          className='store-expand-card '
          items={menuItems}
          defaultSelectedKeys={[selectedRightMenuItem]}
          onClick={(item) => setSelectedRightMenuItem(item.key)}
        />
      </Col>
      <Col span={10} className='p-2' style={{ height: '100%' }}>
        <SelectedMenu
          selectedMenuItem={selectedRightMenuItem}
          store={data}
          loading={loading}
          setLoading={setLoading}
          canEditStores={canEditStores}
        />
      </Col>
    </Row>
  )
}

function SelectedMenu({ selectedMenuItem, store, loading, setLoading, canEditStores }) {
  switch (selectedMenuItem) {
    case 'map_location':
      return <MapLocation store={store} loading={loading} setLoading={setLoading} canEditStores={canEditStores} />
    case 'store_layout_pdf':
      return <LayoutPdf store={store} canEditStores={canEditStores} />
    case 'Unavailable_hours':
      return <UnavailableHours store={store} canEditStores={canEditStores} />
    case 'tank_monitor':
      return <TankMonitor store={store} canEditStores={canEditStores} />
    case 'Site_notes':
      return <SiteNotes store={store} canEditStores={canEditStores} />
    default:
      return null
  }
}
